module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk_primærlogo_neg(hvit).75db9996.png";